export default {
  id: 'l-2',
  navTitleID: 'l-2.navTitle',
  pages: [
    {
      id: 'page-1',
      components: [
        {
          type: 'text',
          titleID: 'title',
          textID: 'text',
          styling: {
            textAlign: 'center'
          }
        }
      ]
    },
    {
      id: 'page-2',
      components: [
        {
          type: 'text',
          titleID: 'title',
          textLayout: 'inverse',
          textID: 'text'
        }
      ]
    },
    {
      id: 'page-3',
      components: [
        {
          type: 'mc-standard',
          questionID: 'question',
          instructionID: 'instruction',
          hintID: 'hint',
          rightFeedbackID: 'feedback-right',
          wrongFeedbackID: 'feedback-wrong',
          options: [
            {
              isCorrect: true,
              textID: 'option-1'
            },
            {
              isCorrect: false,
              textID: 'option-2'
            },
            {
              isCorrect: true,
              textID: 'option-3'
            },
            {
              isCorrect: true,
              textID: 'option-4'
            },
            {
              isCorrect: false,
              textID: 'option-5'
            }
          ]
        }
      ]
    },
    {
      id: 'page-4',
      components: [
        {
          type: 'text',
          titleID: 'title',
          textLayout: 'inverse',
          textID: 'text'
        }
      ]
    },
    {
      id: 'page-5',
      components: [
        {
          type: 'video',
          videoSrc: 'KN_04'
        }
      ]
    },
    {
      id: 'page-6',
      components: [
        {
          type: 'mc-standard',
          questionID: 'question',
          instructionID: 'instruction',
          hintID: 'hint',
          rightFeedbackID: 'feedback-right',
          wrongFeedbackID: 'feedback-wrong',
          options: [
            {
              isCorrect: true,
              textID: 'option-1'
            },
            {
              isCorrect: false,
              textID: 'option-2'
            },
            {
              isCorrect: true,
              textID: 'option-3'
            },
            {
              isCorrect: true,
              textID: 'option-4'
            }
          ]
        }
      ]
    }
  ]
}
